import { useEffect } from "react";
import { cacheApi } from "@api";
import { sessionHelper } from "@utilities";
import { useIsLoggedIn } from "@redux";

/**
 * Hook to periodically cache user resources in the background
 * @param intervalMinutes - Interval in minutes to cache user resources (default: 5 minutes, 0 to disable)
 */
export const useUserResourcesCache = (intervalMinutes: number = 5) => {
    const isLoggedIn = useIsLoggedIn();

    useEffect(() => {
        if (intervalMinutes <= 0) return;

        const cacheUserResources = async () => {
            try {
                if (!isLoggedIn) {
                    if (sessionHelper.hasSession()) {
                        await cacheApi.cacheUserResources(sessionHelper.getSessionId());
                    }
                } else {
                    await cacheApi.cacheUserResources();
                }
            } catch (error) {
                console.error("Failed to cache user resources:", error);
            }
        };

        cacheUserResources();
        const interval = setInterval(cacheUserResources, intervalMinutes * 60 * 1000);

        return () => clearInterval(interval);
    }, [intervalMinutes, isLoggedIn]);
};
